import { Autocomplete } from 'stimulus-autocomplete'

export default class extends Autocomplete {
  commit(event) {
    if (event.dataset.url) {
      Turbo.visit(event.dataset.url)
    } else {
      super.commit(event)
    }
  }
}
